import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { useRouter } from 'next/router';
import React from 'react';
import useStyles from './RawHtml.styles';
import { Box } from '@mui/material';
const RawHtml = React.forwardRef(({ content, className, dataTestId }, ref) => {
    const router = useRouter();
    const { classes } = useStyles();
    const handleAnchorClick = (e) => {
        const targetLink = e.target.closest('a');
        if ((targetLink === null || targetLink === void 0 ? void 0 : targetLink.href) &&
            targetLink.hostname === window.location.hostname &&
            targetLink.protocol === window.location.protocol) {
            // Use router.push for links with same site
            e.preventDefault();
            router === null || router === void 0 ? void 0 : router.push(targetLink.pathname);
        }
    };
    // As markdown content can contain custom tags like <u> for underline as it is deprecated, we convert them to standard HTML tags.
    const convertCustomTags = (html) => {
        var _a;
        if (typeof html !== 'string')
            return html;
        return (_a = html === null || html === void 0 ? void 0 : html.replace(/&lt;u&gt;/g, '<u>')) === null || _a === void 0 ? void 0 : _a.replace(/&lt;\/u&gt;/g, '</u>');
    };
    const convertedMessage = convertCustomTags(content);
    let contentElement = null;
    if (content) {
        if (typeof content === 'string') {
            contentElement = (_jsx(Box, { ref: ref, className: clsx(classes.content, className), onClick: handleAnchorClick, onKeyDown: handleAnchorClick, dangerouslySetInnerHTML: { __html: convertedMessage }, "data-testId": dataTestId }));
        }
        else {
            contentElement = (_jsx(Box, { ref: ref, className: clsx(classes.content, className), onClick: handleAnchorClick, onKeyDown: handleAnchorClick, "data-testId": dataTestId, children: content }));
        }
    }
    return contentElement;
});
RawHtml.displayName = 'RawHtml';
export default RawHtml;
